import { render, staticRenderFns } from "./CampaignGroupDetail.vue?vue&type=template&id=433e70e2&scoped=true"
import script from "./CampaignGroupDetail.vue?vue&type=script&lang=js"
export * from "./CampaignGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./CampaignGroupDetail.vue?vue&type=style&index=0&id=433e70e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433e70e2",
  null
  
)

export default component.exports